import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { ShakeAnimationService } from 'src/app/services/shake-animation/shake-animation.service';

@Component({
  selector: 'ipm-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(private commonService: CommonService,
    private authService: AuthService,
    public shakeAnimation: ShakeAnimationService,
    private ngxSpinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
  }

  sendPasswordResetLink(formData: FormGroup) {
    let className = this.commonService.getClassName('ipm-forgot-model')
    this.clearError(className);
    let sendData = {
      email: formData.value.email
    }
    this.authService.forgotPassword(sendData).subscribe( response => {
      this.commonService.closingPopupWithSendData(sendData.email);
    }, (error) => {
      this.shakeAnimation.addShakeAnimation(className);
      this.shakeAnimation.errorMessage = error.error.message;
    });
  }

  closeByDeviceType() {
      this.commonService.closePopUp();
  }

    /**
 * Clear Error data when change  toggle
 */
  clearError(className:string) {
    this.shakeAnimation.removeClass(className);
  }

  closePopup() {
    this.commonService.closePopUp();
  }

}
